export const LP_URL = '/sol/contents/client/';
export const INPUT_URL = '/clcd/odform/input';
export const CONF_URL = '/clcd/odform/conf';
export const THANKS_URL = '/clcd/odform/thanks';
export const ADD_CONF_URL = '/clcd/odform/add-conf';
export const ADD_THANKS_URL = '/clcd/odform/add-thanks';
export const ADD_JOB_DESCRIPTION_URL = '/clcd/odform/add-job-description';
export const ADD_SKILL_URL = '/clcd/odform/add-skill';
export const ADD_CONDITION_URL = '/clcd/odform/add-condition';
export const ADD_ENVI_URL = '/clcd/odform/add-envi';
export const ADD_INFO_URL = '/clcd/odform/add-info';
export const FIRST_URL = '/clcd/odform/input';

export const DUTY_SKILL_PATH = '/v1/jobsearch/duty/skill';
export const EKI_SUGGEST_PATH = '/v1/jobsearch/ekisuggest';
export const HOURSALARY_SUGGEST_PATH = '/v1/getHourSalary';
export const ADD_SEARCH_PATH = '/v1/addresses/search';
export const REGISTER_ORDER_PATH = '/v1/registerOrder';
export const REGISTER_REQUEST_PATH = '/v1/registerRequest';
export const CHECK_EKICODE_PATH = '/v1/checkEkiCode';

export const BUTTON_NO_PREV = 'BUTTON_NO_PREV';
export const BUTTON_DEFAULT = 'BUTTON_DEFAULT';
export const BUTTON_CONF = 'BUTTON_CONF';
export const BUTTON_BEFORE_CONF = 'BUTTON_BEFORE_CONF';
export const BUTTON_BACKLP = 'BUTTON_BACKLP';
export const BUTTON_NONE = 'BUTTON_NONE';
export const BUTTON_LINK_ONLY = 'BUTTON_LINK_ONLY';
export const BUTTON_NEXT_PREV = 'BUTTON_NEXT_PREV';
export const ROOT_ELEMENT_ID = 'root';

export const CHOICES_NAME_MAP = {
  workCategory: 'ご検討の職種',
  workCategoryOtherDetail: 'その他',
  workDetailText: 'ご依頼内容の詳細',
  companyNameText: '企業名',
  dept: '派遣先部課名',
  chargePersonNameText: 'ご担当者名',
  tel: '電話番号',
  email: 'メールアドレス',
  address: '派遣先住所',
  employmentPlacementDispatching: '紹介予定派遣の希望',
  ekiName: '派遣先最寄り駅',
  desiredStartDate: '就業開始希望日日付指定',

  workTime: '勤務時間',
  overTimeRange: '残業時間',
  workingDayRange: '勤務日数',
  workingDayCmnt: 'その他（シフト勤務など）',
  hourSalaryMax: '請求金額',

  overTime: '残業時間',

  otherComment: 'その他連絡事項',
  dutyCmnt: 'その他事務',
  workInfoContentCmnt: '上記以外の業務内容',
  skillOtherCmnt: 'その他',
  bgdOfRecruitmentCmnt: 'その他',

  ageRange: '職場の年齢層',
  genderRange: '男女比率',
  welfare: '利用可能な福利厚生施設',
  welfareCmnt: 'その他',
  workEnvi: '職場の特徴',
  workEnviCmnt: '上記以外に職場環境の特徴',

  notShow: '非表示',
  require: '必須',
  option: '任意',
  other: 'その他',

  // モーダルエラーメッセージ
  _selectBgdOfRecruitmentCmnt: 'その他',

  _modalDutyCmnt: 'その他事務',
  _modalWICCmnt: '業務内容',
  _modalSkillOtherCmnt: 'その他スキル',
  _modalWorkingDay: '勤務日数',
  _modalWorkingDayCmnt: 'その他',
  _modalOverTimeRange: '残業時間',
  _modalSalaryMax: '請求金額目安（1時間）上限',

  _modalAgeRange: '職場の年齢層',

  _modalCompanyNameText: '企業名',
  _modalDept: '派遣先部課名',
  _modalChargePersonNameText: 'ご担当者名',
  _modalTel: '電話番号',
  _modalEmail: 'メールアドレス',
  _modalAddress: '派遣先住所',
  _modalEkiName: '派遣先最寄り駅',

  _modalWelfare: '利用可能な福利厚生施設',
  _modalWelfareCmnt: 'その他',
  _modalWorkEnvi: '職場環境',
  _modalWorkEnviCmnt: '職場環境',
  _modalWorkTime: '勤務時間',
  _selectWorkPeriod: '就業期間',
  _selectDayOfTheWeek: '勤務日',
};

// エラーメッセージ定義
export const ERROR_MESSAGES = [
  { pattern: /^should NOT be shorter than 1 characters/, label: 'を入力してください' },
  { pattern: /^should NOT be longer than/, label: 'の入力内容が長すぎます' },
  { pattern: /^should match pattern/, label: 'の入力内容が不正です' },
  { pattern: /^should NOT have fewer than 1 items/, label: 'を選択してください' },
  { pattern: /^should NOT have more than 5 items/, label: 'は最大5つまでです' },
  { pattern: /^should match "else" schema/, label: 'の入力内容が不正です' },
  { pattern: /^should be >= 1/, label: 'を入力してください' },
  { pattern: /^should be integer/, label: 'の入力内容が不正です' },
  { pattern: /^should be <= 9999/, label: 'の入力内容が不正です' },
  { pattern: /^xss error/, label: '特殊文字（例: 髙、<、>、① ）が含まれています。別の文字に置き換えてください。' },
];

export const NO_NAME_ERROR_MESSAGES = [
  '特殊文字（例: 髙、<、>、① ）が含まれています。別の文字に置き換えてください。'
];

export const CUSTOM_ERROR_MESSAGES = {
  /* 業務ロジックチェックのエラーメッセージ */
  checkEkiCodeNG: 'サービス対象外エリアです',
  ekiSuggestZero: '該当する駅が見つかりません',
  checkDesiredStartDateNG: '就業開始希望日日付指定の入力内容が不正です',
  checkWorkPeriodDateNG: '就業期間日付指定の入力内容が不正です',
  syuugyouTimeNG: '勤務時間の入力内容が不正です',
  remoteWorkCountNG: 'テレワークの頻度を選択してください',
  hourSalaryApiErr: 'システムの不具合により下限金額が0で表示されていますが、このままお進みください',
};
export const FATAL_ERROR = 'OLOD_FATAL_ERROR';
export const FATAL_ERROR_MESSAGES = [
  '予期せぬエラーが発生しました。',
  '申し訳ありませんが、しばらくたってから再度実行してください。',
];
export const DROPDOWN_INITIAL_ITEM = { value: '', label: '選択する' }; // labelが空だと画面が崩れる

export const DROPDOWN_INITIAL_ITEM_MAP = {
  startTimeHour : { value: '', label: '09' },
  startTimeMinute : { value: '', label: '00' },
  endTimeHour : { value: '', label: '17' },
  endTimeMinute : { value: '', label: '45' },
  startTimeRangeStartHour : { value: '', label: '08' },
  startTimeRangeStartMinute : { value: '', label: '00' },
  startTimeRangeEndHour : { value: '', label: '10' },
  startTimeRangeEndMinute : { value: '', label: '30' },
  endTimeRangeStartHour : { value: '', label: '16' },
  endTimeRangeStartMinute : { value: '', label: '30' },
  endTimeRangeEndHour : { value: '', label: '18' },
  endTimeRangeEndMinute : { value: '', label: '15' },
  overTimeMin : { value: '', label: '00' },
  overTimeMax : { value: '', label: '05' },
  workingDayRangeMin : { value: '', label: '4' },
  workingDayRangeMax : { value: '', label: '5' },
  ageRangeMin : { value: '', label: '20' },
  ageRangeMax : { value: '', label: '40' },
}

export const CHOICES_MAP = {
  /* 項目のテキスト */
  employmentPlacementDispatchingLabel: '紹介予定派遣のみをご希望の方はこちらをチェックしてください',
  workCategoryList: [
    { value: 'A', label: '事務' },
    { value: 'B', label: 'ITエンジニア・WEBクリエイター・その他技術系' },
    { value: 'C', label: '営業・販売・接客' },
    { value: 'D', label: '介護' },
    { value: 'E', label: 'その他' },
  ],
  serviceArea: {
    A: [
      {
        todofu: '関東',
        todofuDtl: '（東京・神奈川・千葉・埼玉・茨城・栃木・群馬）',
      },
      { todofu: '関西', todofuDtl: '（大阪・兵庫・京都・滋賀・奈良）' },
      { todofu: '東海', todofuDtl: '（愛知・岐阜・三重・静岡）' },
      {
        todofu: '北海道・東北',
        todofuDtl: '（北海道・宮城・秋田・岩手・福島）',
      },
      { todofu: '中国・九州', todofuDtl: '（広島・福岡）' },
    ],
    B: [
      { todofu: '関東', todofuDtl: '（東京・神奈川・千葉・埼玉）' },
      { todofu: '関西', todofuDtl: '（大阪・兵庫・京都）' },
      { todofu: '東海', todofuDtl: '（愛知）' }
    ],
    C: [
      { todofu: '関東', todofuDtl: '（東京・神奈川・千葉・埼玉）' },
      { todofu: '関西', todofuDtl: '（大阪・兵庫・京都・奈良）' },
      { todofu: '東海', todofuDtl: '（愛知・岐阜・三重）' },
      { todofu: '北海道・東北', todofuDtl: '（北海道）' },
      { todofu: '中国・九州', todofuDtl: '（福岡）' },
    ],
    D: [{ todofu: '関東', todofuDtl: '（東京・神奈川・千葉・埼玉）' }],
  },
  howToDo: [
    {
      value: '01',
      label: ['WEBで依頼する'],
      subLabel: ['(入力時間目安：6分～8分)'],
    },
    {
      value: '02',
      label: ['電話で依頼する（日時予約に進む）'],
      subLabel: ['(電話時間目安：15分～20分)'],
    },
  ],
  workInfoContentList: [
    { value: '01', label: 'データ入力' },
    { value: '02', label: 'Excelでのデータ集計' },
    { value: '03', label: 'Excelでの資料作成' },
    { value: '04', label: 'PowerPointでの資料作成' },
    { value: '05', label: '電話・来客応対' },
    { value: '06', label: 'ファイリング' },
    { value: '07', label: '備品管理' },
    { value: '08', label: '郵便物対応' },
    { value: '09', label: 'スケジュール調整・連絡 ' },
    { value: '10', label: '上記以外' },
  ],
  bgdOfRecruitmentList: [
    { value: '01', label: '社員の代替' },
    { value: '02', label: '派遣社員の代替' },
    { value: '03', label: '増員' },
    { value: '04', label: '繁忙期対応（期間限定）' },
    { value: '05', label: 'その他' },
  ],
  workEnviList: [
    { value: '01', label: '駅徒歩5分以内' },
    { value: '02', label: '近くにコンビニ・カフェあり' },
    { value: '03', label: '外資系' },
    { value: '04', label: '研修制度あり' },
    { value: '05', label: '禁煙' },
    { value: '06', label: 'オフィスカジュアル' },
    { value: '07', label: '服装自由' },
    { value: '08', label: '制服あり' },
    { value: '09', label: '同業務者あり' },
    { value: '10', label: '喫煙ルーム利用可' },
  ],
  startTimeList: [
    { value: '01', label: '09:00' },
    { value: '02', label: '09:30' },
    { value: '03', label: '10:00' },
    { value: '04', label: '10:30' },
    { value: '05', label: '上記以外' },
  ],
  endTimeList: [
    { value: '01', label: '17:00' },
    { value: '02', label: '17:30' },
    { value: '03', label: '18:00' },
    { value: '04', label: '18:30' },
    { value: '05', label: '上記以外' },
  ],
  desiredStartDateKubunList: [
    { value: '01', label: '即日開始' },
    { value: '02', label: '翌月1日まで相談可' },
    { value: '03', label: '日付指定' },
  ],
  workPeriodList: [
    { value: '03', label: '短期（3か月未満）' },
    { value: '02', label: '長期（終了日未定）' },
    { value: '01', label: 'その他（終了日選択）' },
  ],
  hourList: [
    { value: '00', label: '00' },
    { value: '01', label: '01' },
    { value: '02', label: '02' },
    { value: '03', label: '03' },
    { value: '04', label: '04' },
    { value: '05', label: '05' },
    { value: '06', label: '06' },
    { value: '07', label: '07' },
    { value: '08', label: '08' },
    { value: '09', label: '09' },
    { value: '10', label: '10' },
    { value: '11', label: '11' },
    { value: '12', label: '12' },
    { value: '13', label: '13' },
    { value: '14', label: '14' },
    { value: '15', label: '15' },
    { value: '16', label: '16' },
    { value: '17', label: '17' },
    { value: '18', label: '18' },
    { value: '19', label: '19' },
    { value: '20', label: '20' },
    { value: '21', label: '21' },
    { value: '22', label: '22' },
    { value: '23', label: '23' },
  ],
  minuteList: [
    { value: '00', label: '00' },
    { value: '15', label: '15' },
    { value: '30', label: '30' },
    { value: '45', label: '45' },
  ],
  overTimeHourList: [
    { value: '00', label: '00' },
    { value: '05', label: '05' },
    { value: '10', label: '10' },
    { value: '15', label: '15' },
    { value: '20', label: '20' },
    { value: '25', label: '25' },
    { value: '30', label: '30' },
  ],
  workingDayRangeList: [
    { value: '1', label: '1' },
    { value: '2', label: '2' },
    { value: '3', label: '3' },
    { value: '4', label: '4' },
    { value: '5', label: '5' },
  ],
  attendanceList: [
    { value: '01', label: '休日勤務あり' },
    { value: '02', label: '祝日勤務あり' },
    { value: '03', label: 'テレワーク可能' },
  ],
  remoteWorkCountList: [
    { value: '01', label: '週に1～2日' },
    { value: '02', label: '週に3～4日' },
    { value: '03', label: 'すべてテレワーク' },
  ],
  welfareList: [
    { value: '01', label: '食堂' },
    { value: '02', label: '休憩室' },
    { value: '03', label: '更衣室' },
    { value: '04', label: '医療施設' },
    { value: '05', label: 'その他' },
    { value: '09', label: '該当なし' },
  ],
  ageList: [
    { value: '20', label: '20' },
    { value: '30', label: '30' },
    { value: '40', label: '40' },
    { value: '50', label: '50' },
  ],
  dutyList: [
    { value: 'AA01', label: '一般事務' },
    { value: 'AC01', label: '経理事務' },
    { value: 'AB01', label: '営業事務（受発注業務あり）' },
    { value: 'AB02', label: '営業事務（受発注業務なし）' },
    { value: 'AE01', label: '総務事務' },
    { value: 'AE02', label: '人事事務（全般）' },
    { value: 'AE03', label: '人事事務（採用・教育）' },
    { value: 'AE04', label: '人事事務（給与・社保）' },
    { value: 'AJ02', label: '貿易事務（輸入業務）' },
    { value: 'AJ01', label: '貿易事務（輸出業務）' },
    { value: 'AG01', label: '秘書' },
    { value: 'BD01', label: '受付・案内業務' },
    { value: 'AY99', label: 'その他事務' },
  ],
  // Excelスキル
  excelskillList: [
    { value: '11', label: '入力・修正・保存' },
    { value: '21', label: '四則演算' },
    { value: '22', label: 'SUM・AVERAGE関数' },
    { value: '23', label: 'IF関数' },
    { value: '31', label: 'VLOOK関数' },
    { value: '32', label: 'ピボットテーブル' },
  ],
  // その他スキル
  otherSkillsList: [
    { value: '01', label: 'Word' },
    { value: '02', label: 'Access' },
    { value: '03', label: 'PowerPoint' },
    { value: '04', label: '英語（簡単な英会話）' },
    { value: '05', label: 'TOEIC600点以上' },
    { value: '06', label: 'TOEIC800点以上' },
    { value: '07', label: 'その他外国語' },
    { value: '08', label: '簿記3級以上' },
    { value: '09', label: 'それ以外' },
  ],
  //  男女比率
  genderRangeList: [
    { value: '01', label: '男性が多い' },
    { value: '02', label: '' },
    { value: '03', label: '半数' },
    { value: '04', label: '' },
    { value: '05', label: '女性が多い' },
  ],
};

export const PAGE_MAP = {
  [INPUT_URL]: {
    step: '1',
    subStep: null,
    url: INPUT_URL,
    nextUrl: CONF_URL,
    prevUrl: null,
    buttonType: BUTTON_NONE,
    title: '派遣のご依頼',
  },
  [CONF_URL]: {
    step: '2',
    subStep: null,
    url: CONF_URL,
    nextUrl: THANKS_URL,
    nextOdUrl: THANKS_URL,
    prevUrl: INPUT_URL,
    buttonType: BUTTON_DEFAULT,
    title: 'ご依頼内容の確認',
  },
  [THANKS_URL]: {
    step: '3',
    subStep: null,
    url: THANKS_URL,
    nextUrl: LP_URL,
    prevUrl: CONF_URL,
    buttonType: BUTTON_BACKLP,
    title: ['ご依頼を受け付けました。', '担当よりご連絡いたします。'],
  },
  [ADD_JOB_DESCRIPTION_URL]: {
    step: '4',
    subStep: null,
    url: ADD_JOB_DESCRIPTION_URL,
    nextUrl: ADD_SKILL_URL,
    prevUrl: INPUT_URL,
    buttonType: BUTTON_NEXT_PREV,
    title: '派遣のご依頼',
  },
  [ADD_SKILL_URL]: {
    step: '5',
    subStep: null,
    url: ADD_SKILL_URL,
    nextUrl: ADD_CONDITION_URL,
    prevUrl: ADD_JOB_DESCRIPTION_URL,
    buttonType: BUTTON_NEXT_PREV,
    title: '派遣のご依頼',
  },
  [ADD_CONDITION_URL]: {
    step: '6',
    subStep: null,
    url: ADD_CONDITION_URL,
    nextUrl: ADD_ENVI_URL,
    prevUrl: ADD_SKILL_URL,
    buttonType: BUTTON_NEXT_PREV,
    title: '派遣のご依頼',
  },
  [ADD_ENVI_URL]: {
    step: '7',
    subStep: null,
    url: ADD_ENVI_URL,
    nextUrl: ADD_INFO_URL,
    prevUrl: ADD_CONDITION_URL,
    buttonType: BUTTON_NEXT_PREV,
    title: '派遣のご依頼',
  },
  [ADD_INFO_URL]: {
    step: '8',
    subStep: null,
    url: ADD_INFO_URL,
    nextUrl: ADD_CONF_URL,
    prevUrl: ADD_ENVI_URL,
    buttonType: BUTTON_BEFORE_CONF,
    title: '派遣のご依頼',
  },
  [ADD_CONF_URL]: {
    step: '9',
    subStep: null,
    url: ADD_CONF_URL,
    nextUrl: ADD_THANKS_URL,
    prevUrl: ADD_INFO_URL,
    buttonType: BUTTON_CONF,
    title: 'ご依頼内容の確認',
  },
  [ADD_THANKS_URL]: {
    step: '10',
    subStep: null,
    url: ADD_THANKS_URL,
    nextUrl: LP_URL,
    prevUrl: ADD_CONF_URL,
    buttonType: BUTTON_BACKLP,
    title: [
      'ご依頼いただいた内容で人選を開始します。',
      '担当よりご連絡いたしますのでお待ちください。',
    ],
  },
  default: {
    step: '---',
    subStep: null,
    url: '/',
    nextUrl: '/',
    prevUrl: null,
    buttonType: BUTTON_DEFAULT,
    title: 'タイトル',
  },
};

export const MEASURE_MAP = {
  EVENT_EKI_SELECT: {
    name: '駅選択',
    linkTrackVars: 'eVar1,prop3,prop4,eVar4,prop5,eVar5,prop31,eVar31,prop37,eVar37,prop54,eVar54',
    eVar37: 'D=c37',
  },
  EVENT_82: {
    name: 'オンライン発注フォーム_入力ボタン',
    linkTrackVars: 'eVar1,prop3,prop4,eVar4,prop5,eVar5,prop31,eVar31,events',
    linkTrackEvents: 'event82',
    events: 'event82',
  },
  EVENT_83: {
    name: '派遣依頼_発注完了ボタン',
    linkTrackVars: 'eVar1,prop3,prop4,eVar4,prop5,eVar5,prop31,eVar31,events',
    linkTrackEvents: 'event83',
    events: 'event83',
  },
  EVENT_84: {
    name: '派遣依頼確認画面_次へボタン',
    linkTrackVars: 'eVar1,prop3,prop4,eVar4,prop5,eVar5,prop31,eVar31,events',
    linkTrackEvents: 'event84',
    events: 'event84',
  },
  EVENT_85: {
    name: 'オンライン発注確認画面_送信ボタン',
    linkTrackVars: 'eVar1,prop3,prop4,eVar4,prop5,eVar5,prop31,eVar31,events',
    linkTrackEvents: 'event85',
    events: 'event85',
  },
  EVENT_112: {
    name: 'ODフォーム_電話依頼選択の次へボタン',
    linkTrackVars: 'eVar1,prop3,prop4,eVar4,prop5,eVar5,prop31,eVar31,events',
    linkTrackEvents: 'event112',
    events: 'event112',
  },
};

// debug, storybook用のダミーパラメータ
export const debugInitialState = {
  /* Input */
  workCategory: 'A',
  workCategoryOtherDetail: '',
  workDetailText: '詳細が入る',

  /* Input or Add-Info */
  companyNameText: '企業',
  dept: '派遣先部課名',
  chargePersonNameText: 'なまえ',
  tel: '09011112222',
  email: 'test@r-staffing.co.jp',
  address: '東京都中央区',
  employmentPlacementDispatching: false,

  ekiCd: '22828',
  ekiName: '東京',

  /* Add-Input */
  howToDo: '01',
  bgdOfRecruitment: '01',
  bgdOfRecruitmentCmnt: '',
  desiredStartDateKubun: '01',
  desiredStartDate: '',
  workPeriod: '02',
  workPeriodDate: '',

  /* AddJobDescription */
  duty: [ 'AA01', 'AY99' ],
  dutyCmnt: 'その他職種',
  workInfoContent: [ 'CZZ01032J', 'CZZ01010J', 'CZZ01026J', 'CZZ01001J', 'CZZ61008J' ],
  workInfoContentCmnt: '詳細',
  apiSkillList: [],

  /* AddSkill */
  excelSkill: ['11','32'],
  otherSkills: ['01','03'],
  skillOtherCmnt: 'その他希望スキル',

  /* Add-Condition */
  startTime: [ '08', '00' ],
  endTime: [ '16', '00' ],
  startTimeRangeStart: [ '', '' ],
  startTimeRangeEnd: [ '', '' ],
  endTimeRangeStart: [ '', '' ],
  endTimeRangeEnd: [ '', '' ],
  overTimeRange: [ '00', '05' ],
  workingDayRange: [ '3', '5' ],
  workingDayRangeOthers: false,
  workingDayCmnt: '',
  attendance: [ '01' ],
  remoteWorkCount: '02',
  hourSalaryMin: 1750,
  hourSalaryMax: 3000,

  /* AddEnvi */
  welfare: [ '01', '02' ],
  welfareCmnt: '',
  workEnvi: [ '01', '02', '03', '04', '05', '06', '07' ],
  ageRange: [ '20', '30' ],
  genderRange: '01',
  workEnviCmnt: '職場環境（自由入力）',

  /* Add-Conf */
  otherComment: '',

  isModify: false,
  validMap: {
    [INPUT_URL]: true,
    [CONF_URL]: true,
    [THANKS_URL]: true,
    [ADD_CONF_URL]: true,
    [ADD_THANKS_URL]: true,
    [ADD_JOB_DESCRIPTION_URL]: true,
    [ADD_SKILL_URL]: true,
    [ADD_CONDITION_URL]: true,
    [ADD_ENVI_URL]: true,
    [ADD_INFO_URL]: true,
  },
  isRegistered: false,
  isAddRegistered: false,
  hourSalaryLoading: true,

  receiptID: '',
  clickID: 'clickID12345',
  mediaID: 'mediaID12345',
};

export const MOVE_CONF_MSG = '他のページに移動しますか？入力したデータは保存されません。';

export const THANKS_TEXT = {
  information: '依頼内容の修正や確認事項がございましたら、下記までご連絡ください。',
};

export const ADD_THANKS_TEXT = {
  information: '依頼内容の修正や確認事項がございましたら、下記までご連絡ください。',
};

export const ADD_CONF_OD_TITLE_TEXT = {
  jdTitle: '募集背景・業務・スキル',
  basicInfo: '基本情報',
  workDetail: '就業条件',
  desiredStartDate: '就業開始日',
  workPeriod: '就業期間',
  duty: '職種',
  workTime: '勤務時間',
  salary: '請求金額目安',
  jd: '業務内容',
  otherSkill: 'その他スキル',
  jobInfo: '職場環境',
  workEnvi: '職場の特徴',
  bgdOfRecruitment: '募集背景',
  buttonChange: 'この内容で変更する',
  otherComment: 'その他連絡事項',
  excelSkill: 'Excelスキル',
  attendance: '勤務条件',
  ageRange: '職場の年齢層',
  genderRange: '男女比率',
};

export const ADD_INPUT_CONF_TITLE = {
  workEnvi: '職場環境を教えてください（複数選択可）',
  remoteWork: '派遣スタッフのテレワークは可能ですか？',
  remoteWorkCount: 'テレワークの頻度を選択してください',
  welfare: '福利厚生で該当するものを選択ください',
};

export const COMMENT_MAP = {
  // 派遣先部課名
  deptCmnt: {
    value: '',
    title: '',
    subTitle: '',
    popUpTitle: '',
    popUpDetail: ['派遣先部課名がない場合は「なし」と入力してください'],
  },
  // 職種
  dutyCmnt: {
    value: 'AY99',
    title: 'ご検討の職種を記載してください',
    subTitle: '',
    popUpTitle: '',
    popUpDetail: '',
  },
  // 業務内容
  workInfoContentCmnt: {
    value: '', // 連動する親項目の値を設定する
    title: '上記以外の業務内容がある場合は入力してください',
    subTitle: '',
    popUpTitle: '',
    popUpDetail: '',
  },
  // その他スキル
  skillOtherCmnt: {
    value: '',
    title: 'その他、ご希望のスキルや経験について、必要な場面や理由を含めて教えてください',
    subTitle: '',
    popUpTitle: '',
    popUpDetail: '',
    placeholder: '例）英語：TOEIC600点以上　使用頻度：週2～3回（定型作業）\n　　使用用途：海外のお客様と英語のメールでやり取りが発生します。'
  },
  // 募集背景
  bgdOfRecruitmentCmnt: {
    value: '05',
    title: 'その他の場合は募集背景について記入してください',
    subTitle: '',
    popUpTitle: '',
    popUpDetail: '',
  },
  // 勤務日数の調整可能範囲
  workingDayRangeOthersCmnt: {
    value: '',
    title: 'その他の場合は勤務日数、曜日、条件を入力してください',
    subTitle: '',
    popUpTitle: '',
    popUpDetail: '',
    placeholder: '例）\n週5日、必ず勤務する曜日：月、木、金、土\n※火曜日、水曜日も出勤の場合があり、日曜日+シフトで1日休みの週休2日制です。'
  },
  // テレワーク頻度
  remoteWorkCount: {
    value: '03',
    title: 'テレワークの頻度を選択してください',
    subTitle: '',
    popUpTitle: '',
    popUpDetail: '',
  },
};

export const POINT_COMMENT_MAP = {
  introPointCmnt: {
    labelList: [
      'リクルートスタッフィングの公式キャラクター、リック＆スーです。',
      'ここからは私たちが補足説明や依頼時のポイントをお伝えします。',
      'ぜひ参考にしてください！',
    ],
    pattern: '01',
  },
  desiredStartDatePointCmnt: {
    labelList: [
      '求職者は2か月以上前からお仕事を探す方も多く、就業開始希望日は即日より少し先に設定していただくと、応募数の増加に繋がります。',
    ],
    pattern: '02',
  },
  basicInfomationCmnt: {
    labelList: [
      '部課名がない場合は「なし」と記載してください。',
      '住所は派遣先となる就業場所の住所を番地まで記載してください。',
      'なお、エリアによってサービス対象外となりますのでご了承ください。',
    ],
    pattern: '03',
  },
  workTimePointCmnt: {
    labelList: [ 
      '始業が10時以降、終業が17時以前、勤務日数週4日以下など、調整が可能な場合は入力をお願いします。',
      'スキルや経験がマッチする方々の応募数の増加に繋がります。'
    ],
    pattern: '03',
  }, 
  jdPointCmnt: {
    labelList: [
      '割合の多い職種を２つまでお選びください。',
      '例）総務人事職：総務事務と人事事務を選択',
      '該当の職種がない場合は「その他事務」を選択してください。',
    ],
    pattern: '01',
  },
  skillPointCmnt: {
    labelList: [
      'スキルについて、使う頻度・用途や、明確なレベルのイメージがある場合は備考欄に詳細を記載してください。',
    ],
    pattern: '03',
  },
  enviPointCmnt1: {
    labelList: [
      '福利厚生施設について、派遣先の社員が利用可能な食堂・休憩室・更衣室などについては、派遣スタッフも同様に利用機会を与える義務が課されています。',
    ],
    pattern: '03',
  },
  enviPointCmnt2: {
    labelList: [
      '職場環境について、アピールポイントがあれば教えてください。',
    ],
    pattern: '02',
  }
};

export const PMARK = {
  DEV: 'https://www-dev100.r-staffing.co.jp/sol/contents/img/footer/footer_privacy.png',
  STG: 'https://www-stg.r-staffing.co.jp/sol/contents/img/footer/footer_privacy.png',
  MAIN: 'https://www.r-staffing.co.jp/sol/contents/img/footer/footer_privacy.png',
};

export const TEL_TOOL_LINK = {
  STG: 'https://app.spirinc.com/t/XftIcR-S3ztsq16Cg1ETZ/as/sMCmdSFyDgUOoUC9SspDy/confirm',
  MAIN: 'https://app.spirinc.com/t/XftIcR-S3ztsq16Cg1ETZ/as/ZA7G8ZS2dQm1wqpJILOVl/confirm',
};
